import JSZip from "jszip";

// import { graphingMap } from "../../Charts/chartService"

interface GraphingMap {
  [key: string]: {
    name: string;
    unit: string;
  };
}

// The following is used to expand the header with name and unit. Copied from chartService.
// chartService cannot be used, because all of these will be displayed on the graph, which we don't want.
const graphingMap: GraphingMap = {
  "p": { name: "pressure", unit: "millibar" },
  "v": { name: "velocity", unit: "m/s" },
  "t": { name: "temperature", unit: "C" },
  "d": { name: "direction", unit: "degrees" },
  "rp": { name: "water_column_height", unit: "cm" },
  "wl": { name: "water_level", unit: "cm" },
  "discharge": { name: "discharge", unit: "m3/s" },
  "dp": { name: "wave_height", unit: "cm" },
  "w": { name: "wave_interval", unit: "seconds" },
  "ap": { name: "air_pressure", unit: "millibar" },
  "at": { name: "air_temperature", unit: "C" },
  "ts": { name: "uptime", unit: "ms" },
  "ts2": { name: "timestamp", unit: "local"}
  // "x": { name: "x", unit: "" },
}


const graphingMapKeys = Object.keys(graphingMap);

/* function createEmptyArrayObject() {
  let obj: any = {}
  graphingMapKeys.forEach((key: string) => obj[key] = [])
  return obj
} */

export const exportFile = (data, options) => {
  const zip = new JSZip();
  const files = data.reduce((total, num) => { // Create separate files" for each device id
    num.data.forEach((oneData) => {
      const deviceID = oneData.device_id;
      if (!total[deviceID]) {
        total[deviceID] = [];
      }
      total[deviceID].push(oneData);
    });
    return total;
  },
  {});

  for (const deviceID in files) {
    const deviceData = files[deviceID];
    let headers = Object.keys(deviceData[0]);
    // Move columns around, so timestamp is first and sensor name is second.
    for (let t=0; t<headers.length; t++) {
      if ((headers[t] === "ts2") && (t > 0)) {
        headers[t] = headers[0];
        headers[0] = "ts2";
      }
      if ((headers[t] === "device_id") && (t !== 1)) {
        headers[t] = headers[1];
        headers[1] = "device_id";
      }
    }
    let newheaders = Object.keys(deviceData[0]);
    for (let t=0; t<headers.length; t++) {
      if (graphingMap[headers[t]] !== undefined) {
        newheaders[t] = headers[t] + " (" + graphingMap[headers[t]].name + " [" + graphingMap[headers[t]].unit + "])";
      }
      else { newheaders[t] = headers[t]; }
    }
    // console.log(headers);
    const csvData = deviceData.map((datum) => headers.map((header) => datum[header]).join(","));
    const csvString = [headers.join(","), newheaders.join(","), ...csvData].join("\n");
    const fileName = options.filename + `-device-${deviceID}` + options.filetype;
    zip.file(fileName, csvString)
  }
  zip.generateAsync({type: 'blob'}).then(function(blob) {
    downloadFile(blob, options);
  });
};

const downloadFile = (blob, options) => { // Creates download link and downloads zip file
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = options.filename + '.zip';
  link.href = url;
  link.click();
}
